// Make jQuery injectable using name 'mjQ' (easy to grep)
import angular from 'angular';
const jq_mod = angular.module('mw.jquery', []);
export default jq_mod.name;
jq_mod.factory('mjQ', ['$window', function ($window) {
        // this will remove global $ and window.jQuery
        // http://stackoverflow.com/questions/7937507/how-to-encapsulate-jquery
        //
        // .. but we can't do as long as we have code using $ directly
        // var jq = $window.jQuery.noConflict(true);
        var jq = $window.$;
        return jq;
    }]);
